import { useEffect, useRef, useState } from 'react';
import './article-navigation.css';

export default function ArticleNavigation({ items }) {
  const [active, setActive] = useState(items[0]?.id);
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  useEffect(() => {
    const sections = items.map(({ id }) => document.getElementById(id)).filter(Boolean);
    let frame;
    const update = () => {
      frame = undefined;
      const offset = window.innerWidth <= 1024 ? 220 : 130;
      let current = sections[0]?.id;
      for (const section of sections) {
        if (section.getBoundingClientRect().top <= offset) current = section.id;
      }
      setActive(current);
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
    };
  }, [items]);
  const jump = (event, id) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    setOpen(false);
    window.history.replaceState(null, '', '#' + id);
    requestAnimationFrame(() => {
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    target.focus({ preventScroll: true });
    });
  };
  const current = items.find(({ id }) => id === active);
  return (
    <aside ref={root} className="article-toc article-navigation" aria-label="Содержание">
      <button className="article-toc-mobile" aria-expanded={open} aria-controls="article-chapters" onClick={() => setOpen(!open)}>
        <span>Содержание<span className="article-current">{current?.title}</span></span><span aria-hidden="true">{open ? '−' : '+'}</span>
      </button>
      <div className={'article-chapters' + (open ? ' is-open' : '')} id="article-chapters">
        <div className="eyebrow article-toc-desktop">СОДЕРЖАНИЕ</div>
        <nav aria-label="Главы статьи"><ol>
          {items.map(({ id, title }) => <li key={id}><a href={'#' + id} onClick={(event) => jump(event, id)} aria-current={active === id ? 'location' : undefined}>{title}</a></li>)}
        </ol></nav>
      </div>
      <div className="article-reading-actions">
        <a href="/blog/">← Все статьи</a>
        <button type="button" onClick={() => { setOpen(false); window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); }}>Наверх ↑</button>
      </div>
    </aside>
  );
}
